<div *ngIf="formControl" [innerHTML]="getSanitizedValue(formControl.value) | sanitizedHtml" [ngStyle]="textAlignStyle"></div>
